'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionHoldService', function (TransactionHoldRepository, TransactionsModel) {

    this.updateTransactionHoldStatus = function updateTransactionHoldStatus(transactions, holdStatus, closePopover) {
      var transactionHoldsToUpdate = constructRequestBody(
        filterTransactionsToUpdateHoldStatus(transactions, holdStatus),
        holdStatus
      );

      return TransactionHoldRepository
        .updateTransactionHolds(transactionHoldsToUpdate)
        .then(function () {
          closePopover();
          return TransactionsModel.refreshTransactions(_.map(transactionHoldsToUpdate, 'id'));
        });
    };

    function filterTransactionsToUpdateHoldStatus(transactions, holdStatus) {
      return _.filter(transactions, function (transaction) {
        return transaction.transactionHold.hold !== holdStatus.status;
      });
    }

    function constructRequestBody(transactions, holdStatus) {
      return _.map(transactions, function (transaction) {
        return {
          id: transaction.id,
          hold: holdStatus.status,
          holdReason: holdStatus.reason
        };
      });
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionHoldService.js
// module id = 650
// module chunks = 0